// src/components/routing/AdminRoute.jsx
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

const AdminRoute = ({ children }) => {
    const { user, loading, hasPermission } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="flex justify-center items-center h-screen">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-purple-500"></div>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (user?.must_change_password && location.pathname !== '/change-password') {
        return <Navigate to="/change-password" replace />;
    }

    // Admin permission check using canonical permission
    if (!hasPermission('system.control')) {
        // Non-admin users are redirected appropriately
        if (user?.role === 'vendor' || user?.restaurant_id) {
            return <Navigate to="/vendor/dashboard" replace />;
        }
        return <Navigate to="/login" replace />;
    }

    return children;
};

export default AdminRoute;
